'use client';

import { CookieProvider } from '@/app/cookie-provider';
import { HostProvider } from '@/app/[domain]/host-provider';
import { ReactNode } from 'react';

type ProvidersProps = {
  children: ReactNode;
  host: string;
  cookies: {
    cartId?: string;
    multiOrigin?: boolean;
    isActiveSiteProtection?: boolean;
    restrictAge?: boolean;
  };
};

export default function StoreFrontProviders({ children, host, cookies }: ProvidersProps) {
  return (
    <CookieProvider cookies={cookies}>
      <HostProvider host={host}>{children}</HostProvider>
    </CookieProvider>
  );
}
